import Repository from './Repository';

const resource = '/monitoramentos';

export default {
  getDadosUnidades(mapeamento, unidade) {
    if (!unidade) {
      return Repository.get(`${resource}/mapeamento/${mapeamento}/unidades`);
    }
    return Repository.get(`${resource}/mapeamento/${mapeamento}/unidades/?unidade=${unidade}`);
  },
  getDadosMapeamento(mapeamento, unidade) {
    if (!unidade) {
      return Repository.get(`${resource}/mapeamento/${mapeamento}`);
    }
    return Repository.get(`${resource}/mapeamento/${mapeamento}/?unidade=${unidade}`);
  },
  getDadosPerfil(filtro) {
    return Repository.post(`${resource}/perfil/geral`, filtro);
  },
  getRelatorioPerfil(filtro) {
    return Repository.post(`${resource}/perfil/relatorio`, filtro);
  },
};
